module.exports = __webpack_public_path__ + "img/451026.d198280a.png";